const barcodeScannerTemplate = ({ showTip }) => {
  const tipContent = showTip
    ? `<div class="barcode-scanner__tip" id="js-bs-how-to">
        <img 
        src="https://assets.homedepot-static.com/images/v1/barcode2.svg" 
        alt="barcode" 
        class="barcode-scanner__bs-image" />
        <span class="u__bold">Scan Card Barcode</span>
      </div>`
    : '';

  return `
    <div id="js-bs__image-capture" class="barcode-scanner barcode-scanner--off-screen-left">
      <div id="js-bs__view-port" class="barcode-scanner__view-port">
      </div>
      ${tipContent}
      <span class="barcode-scanner__close" id="js-close-barcode-scanner">x</span>
    </div>
  `;
};

export default barcodeScannerTemplate;
